import {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import Menu from "./Menu";
import CardMenu from "../../components/card-menu";
import {Card} from "react-bootstrap";
import Icon from "../../components/icon";
import {useEnterprise} from "./EnterpriseProvider";


const DomainsList = () => {
    const {enterprise, loading} = useEnterprise();
    const idEnterprise = enterprise?._id?.$oid;

    const searchColumn = 'name'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const EnterpriseMenu = Menu({id: idEnterprise})


    const fetchEntities = async () => {
        let filters = {
            limit        : currentLimit,
            offset       : currentOffset,
            sortBy       : "created_at",
            sortOrder    : currentOrder,
            id_enterprise: idEnterprise,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/domains/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        if(!loading){
            fetchEntities().then((entities) => {
                setEntities(entities);
                setIsLoading(false);
            });
        }
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange, loading]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/domains/delete",
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );


        }
    };


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        card          : false,
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Name", prop: "name", size: 25, output: (entity) => {
                    return <Link to={`/enterprises/${idEnterprise}/domains/${entity?._id?.$oid}`}>
                        <strong>{entity?.name}</strong>
                    </Link>;
                }
            },
            {
                label: "Enterprise", size: 25, prop: "enterprise", output: (entity) => {
                    return entity?.Enterprise?.name
                }
            },
            {
                label: "Protocol", prop: "protocol", output: (entity) => {
                    return entity?.settings?.use_ssl ? "Https" : "Http"
                }
            },
            {
                label: "Web Ready", prop: "web_ready", output: (entity) => {
                    return entity?.settings?.http_ready ? <Icon name="check" color="#0e9b8a"/> :
                        <Icon name="alert" color="#f00"/>
                }
            },
            {
                label: "Mail Ready", prop: "mail_ready", output: (entity) => {
                    return entity?.settings?.mail_ready ? <Icon name="check" color="#0e9b8a"/> :
                        <Icon name="alert" color="#f00"/>
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/emails/:id`,
            label: "Edit email",
            icon : "edit"
        }
    };


    return (
        <Card>
            <CardMenu {...EnterpriseMenu} />
            <ListingTable {...ListingOptions} />
        </Card>
    )
}

export default DomainsList;